/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_Listing_EyebrowInputs */

const en_directory_platforms_listing_eyebrow = /** @type {(inputs: Directory_Platforms_Listing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform directory`)
};

const zh_directory_platforms_listing_eyebrow = /** @type {(inputs: Directory_Platforms_Listing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台目录`)
};

/**
* | output |
* | --- |
* | "Platform directory" |
*
* @param {Directory_Platforms_Listing_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_listing_eyebrow = /** @type {((inputs?: Directory_Platforms_Listing_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Listing_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_listing_eyebrow(inputs)
	return zh_directory_platforms_listing_eyebrow(inputs)
});
export { directory_platforms_listing_eyebrow as "directory.platforms.listing_eyebrow" }